module.exports = __webpack_public_path__ + "static/img/more_industry.d184d71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/more_industry.png
// module id = Ngj6
// module chunks = 1